<template>
  <div>
    <button
      v-if="showButton && !neverShowButton"
      class="tw-bg-red-500 tw-cursor-pointer tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded tw-border tw-border-transparent"
      @click="redirectToCheckout"
    >
      <span v-if="trialEndDate">
        Save your payment method to continue your access after your trial ends on {{ trialEndDate.toLocaleDateString() }}
      </span>
      <span v-else>
        Save your payment method to continue your access.
      </span>
    </button>
    <o-modal
      :active.sync="showModal"
      :can-cancel="false"
    >
      <button
        class="tw-bg-red-500 tw-cursor-pointer tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded tw-border tw-border-transparent"
        @click="redirectToCheckout"
      >
        <span v-if="trialEndDate">
          Your trial expired on {{ trialEndDate.toLocaleDateString() }}. Save a payment method to continue your access.
        </span>
        <span v-else>
          Save a payment method to continue your access.
        </span>
      </button>
    </o-modal>
  </div>
</template>

<script>

export default {
  props: {
    neverShowButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showButton: false,
      trialEndDate: '',
      showModal: false,
    };
  },
  created() {
    this.checkSubscription();
  },
  methods: {
    async checkSubscription() {
      // TODO make this work and move to parent
      const response = await fetch('/api/v1/subscription/status');
      const { status, trial_end_date } = await response.json();
      console.log('STATUS', status);
      console.log('TRIAL END DATE', trial_end_date);
      const currentDate = new Date();
      const trialEndDate = new Date(trial_end_date);
      this.trialEndDate = trialEndDate;
      if (trial_end_date === null) {
        this.showButton = false;
        this.showModal = false;
      } else if (status === 'trialing' && trialEndDate < currentDate) {
        console.log('INSIDE SHOW MODAL');
        this.showModal = true;
      } else if (status === 'trialing' && trialEndDate > currentDate) {
        this.showButton = true;
      } else if (status === 'active') {
        this.showButton = false;
      }
    },
    async redirectToCheckout() {
      const response = await fetch('/api/v1/subscription/get-checkout-url');
      const { redirect } = await response.json();
      window.location.href = redirect;
    },
  },
};
</script>
